import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { CustomerProfilesPermissions } from './customer-management.customer-profiles.permissions';

export class CustomerProfileOrdersPermissions {
  static GroupName = `${CustomerProfilesPermissions.GroupName}.Orders`;

  static getPermissions = getGroupPermissionFactory(
    CustomerProfileOrdersPermissions.GroupName,
  );

  static Permissions = {
    ReadAll: CustomerProfileOrdersPermissions.getPermissions(
      PermissionEnum.READ_ALL,
    ),
  };
}
